export const environment = {
    production: false,
    cognitoUserPoolId: "ap-southeast-2_7HzoF0e8n",
    cognitoAppClientId: "386q7f2eavcqro2prvmbivjlcb",
    apiUrl: "https://iou-api-demo.sempre.gen.nz"
};
